import { Scenarios } from '@jfs/network'

const getBeneficiaryListApi = {
  default: [
    {
      url: /beneficiary\/remitterId/,
      method: 'GET',
      response: [
        {
          createdBy: 'Sara',
          updatedBy: 'Sara',
          createdAt: 1660042019617,
          updatedAt: 1660042019617,
          beneId: '1012222158619638000',
          remitterId: '2000124276',
          productId: '2222222',
          accountId: 'SCB23232323232',
          beneType: 'MMID',
          beneAccountNumber: 'SCB00012345',
          beneAccountHolderName: 'Pokharkar',
          beneNickName: 'Sara',
          accountType: 'Saving',
          beneIfscCode: 'scb12121',
          beneEmailId: 'SARApatil@gmail.com',
          beneMobileCountryCode: 91,
          beneMobileNumber: 7722075595,
          beneDescription: 'Test',
          beneStatus: 'ACTIVE',
          statusReasonCode: '123',
          field1: null,
          field2: null,
          field3: null,
          field4: null,
          field5: null,
          createdFromChannel: 'JIO',
          updatedFromChannel: 'JIO',
        },
        {
          createdBy: 'Sara',
          updatedBy: 'Sara',
          createdAt: 1659973962066,
          updatedAt: 1659973962066,
          beneId: '1012222076962122000',
          remitterId: '2000124276',
          productId: '2222222',
          accountId: 'SCB23232323232',
          beneType: 'MMID',
          beneAccountNumber: 'SCB00012345',
          beneAccountHolderName: 'Pokharkar',
          beneNickName: 'Sara',
          accountType: 'Saving',
          beneIfscCode: 'scb12121',
          beneEmailId: 'SARApatil@gmail.com',
          beneMobileCountryCode: 91,
          beneMobileNumber: 7722075595,
          beneDescription: 'Test',
          beneStatus: 'ACTIVE',
          statusReasonCode: '123',
          field1: null,
          field2: null,
          field3: null,
          field4: null,
          field5: null,
          createdFromChannel: 'JIO',
          updatedFromChannel: 'JIO',
        },
      ],
      delay: 500,
    },
  ],
  failed: [
    {
      url: /beneficiary\/remitterId/,
      method: 'GET',
      responseCode: 501,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { getBeneficiaryListApi }
